import React, {useCallback, useEffect, useState} from 'react';
import {FieldComponent} from '../../../types/FieldComponent';
import {TimeFilter} from '../filters/TimeFilter';
import {
  Button,
  IconButton,
  Stack,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import api from '../../../services/api';
import toast from 'react-hot-toast';
import {MoreOptions} from '../assets/MoreOptions';
import ConfirmDialog from '../layout/ConfirmDialog';
import AddIcon from "@mui/icons-material/Add";
import {SlidingPaneAddNew} from "../../Page/SlidingPaneAddNew";
import {room} from "../../../schema/room";
import {SlidingPaneEdit} from "../../Page/SlidingPaneEdit";
import CloudDoneRoundedIcon from "@mui/icons-material/CloudDoneRounded";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import Grid from "@mui/material/Grid";
import {ConfirmationTable} from "../../../modules/service-provider/components/ConfirmationTable";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {CurrencyExchange} from "@mui/icons-material";

const Item = styled(Paper)(({theme}) => ({
  backgroundColor: 'transparent',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderRadius: 0,
  boxShadow: '0px -1px 1px 1px #e3e3e3',
  height: '100%'
}));

const ItemWhite = styled(Paper)(({theme}) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: '5px',
  borderRadius: 0,
  boxShadow: '0px -1px 1px 1px #e3e3e3',
  height: '100%'
}));


export const CustomFieldForAccommodationRoom: FieldComponent<any, any> = ({
                                                                            onChange,
                                                                            isActive,
                                                                            value,
                                                                            hasTooltip,
                                                                            disabled,
                                                                            mui,
                                                                            column,
                                                                            allValue,
                                                                            defaultValue,
                                                                            title,
                                                                          }) => {
  const [guides, setGuides] = useState<any>([]);
  const [summary, setSummary] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: room,
    row: {},
  });
  const [fullTotal, setFullTotal] = useState<string>('');
  const [splitLoading, setSplitLoading] = useState(false);

  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({
    schema: room,
    row: {},
  });
  const [query, setQuery] = React.useState<'idle' | 'progress' | 'success'>(
    'idle'
  );
  const timerRef = React.useRef<ReturnType<typeof setTimeout>>();

  const fetchGuides = useCallback(() => {
    setLoading(true);

    api.get(`/accommodation-reservations/rooms/${allValue?.id}`).then((result: any) => {
      setGuides(result);

      const total = result.reduce((sum: number, room: any) => {
        return sum + Number(room?.price_per_night || 0) * Number(room?.quantity || 1);
      }, 0);

      setFullTotal(total.toFixed(2));
      setLoading(false);
    });
  }, [allValue?.id]);

  const fetchRoomPrices = useCallback(() => {
    setLoading(true);
    api.post(`/accommodation-reservations/${allValue?.id}/calculate-prices`, {
      rooms: guides,
      sales_price_person_night: allValue?.sales_price_person_night,
    }).then((result: any) => {
      setSummary(result);
    });
  }, []);

  useEffect(() => {
    fetchGuides();
    fetchRoomPrices();
  }, []);
  const handleDelete = (guideId: number) => {
    api
      .delete(`/rooms/${guideId}`)
      .then((result: any) => {
        toast.success(`Successfully deleted room`);

        setOpenConfirmDialog(false);
        setGuides(guides.filter((guide: any) => guide.id !== guideId));
      })
      .catch((error: any) => {
        toast.error(`Error while deleting room`);
      });
  };

  const handleSplitToRooms = async () => {
    setSplitLoading(true);

    try {
      await api.post(
        `/accommodation-reservations/${allValue?.id}/split-room-prices`,
        {
          total: Number(fullTotal),
        }
      );

      toast.success('Room prices updated successfully');
      fetchGuides();
      fetchRoomPrices();
    } catch (error) {
      toast.error('Error while splitting room prices');
    }
    setSplitLoading(false);
  };

  return (
    <>

      <Box sx={{
        flexGrow: 1,
        width: '100%'
      }}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={8} lg={8}>
            <Item>
              <TableContainer component={Paper}>
                <Table
                  aria-label="simple table"
                  size="small"
                  sx={{
                    '& .MuiTableRow-root .MuiTableCell-root': {
                      p: '5px',
                    },
                  }}
                >
                  <TableHead
                    sx={{
                      '& .MuiTableCell-root': {
                        color: 'inherit',
                        border: 'none',
                      },
                      '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                        border: 'none',
                        fontSize: '14px',
                        p: '10px',
                      },

                      background: '#256861',
                      color: '#fff',
                    }}
                  >
                    <TableRow>
                      <TableCell>Room Type</TableCell>
                      <TableCell>Room Count</TableCell>
                      <TableCell>Room Size</TableCell>
                      <TableCell>Price / Room / Night</TableCell>
                      <TableCell>Price / Person / Night</TableCell>
                      <TableCell>Currency</TableCell>
                      <TableCell
                        sx={{
                          width: '50px',
                          textAlign: 'center',
                        }}
                      >
                        #
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {guides.map((guide: any) => {
                      return (
                        <TableRow>
                          <TableCell>{guide?.room_type?.name}</TableCell>
                          <TableCell>{guide?.quantity}</TableCell>
                          <TableCell>{guide?.room_size}</TableCell>
                          <TableCell>{guide?.price_per_night}</TableCell>
                          <TableCell>{guide?.price_per_person_per_night}</TableCell>
                          <TableCell>{guide?.currency?.name}</TableCell>
                          <TableCell>
                            <MoreOptions
                              clickOnEdit={() => {
                                setOpenedSlidingPane({
                                  ...openedSlidingPane,
                                  ['row']: guide,
                                });
                              }}
                              clickOnDelete={() => {
                                setOpenConfirmDialog(guide);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                alignItems={{ xs: 'stretch', md: 'center' }}
                justifyContent="space-between"
                sx={{
                  mt: 2,
                  p: 2,
                  background: '#fff',
                  boxShadow: '0px -1px 1px 1px #e3e3e3',
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography variant="subtitle1" sx={{ minWidth: 100 }}>
                    Full total
                  </Typography>

                  <TextField
                    size="small"
                    type="number"
                    value={fullTotal}
                    onChange={(e) => setFullTotal(e.target.value)}
                    inputProps={{ step: '0.01', min: 0 }}
                    sx={{ width: 180 }}
                  />

                  <Typography variant="body2">EUR</Typography>
                </Stack>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSplitToRooms}
                  disabled={splitLoading || !guides?.length}
                >
                  Split to rooms
                </Button>
              </Stack>


            </Item>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <Item>
              <Grid container spacing={1}>

                {summary
                  .map((section: any, sectionIndex: number) => (
                    <Grid item xs={12} md={6} lg={6}>
                      <Stack key={sectionIndex} spacing={1}>
                        <Typography variant="body1">{section.name}</Typography>

                        {section.values?.map((item: any) => (
                          <ItemWhite key={`${section.name}-${item.key}`}>
                            <Typography variant={'body2'}>
                              {item.name}: <b>{item.value} EUR</b>
                            </Typography>
                          </ItemWhite>
                        ))}
                      </Stack>
                    </Grid>
                  ))}
              </Grid>
            </Item>
          </Grid>
        </Grid>
      </Box>


      <Stack
        direction={'row'}
        gap={'2px'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          onClick={() => {
            setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: allValue});
          }}
          size={'small'}
        >
          <AddIcon color={'primary'} fontSize={'small'}/>
        </IconButton>

        <IconButton
          onClick={() => {
            fetchGuides();
          }}
          size={'small'}
        >
          <RefreshRoundedIcon color={'primary'} fontSize={'small'}/>
        </IconButton>

        <IconButton
          onClick={() => {
            fetchRoomPrices();
          }}
          size={'small'}
        >
          <CurrencyExchange fontSize={'small'} color={'success'}/>
        </IconButton>

        <Stack>
          {query === 'success' ? (
            <Stack direction={'row'} alignItems={'center'}>
              <CloudDoneRoundedIcon color={'disabled'}/>
              <Typography variant={'caption'} marginLeft={'5px'} color={'gray'}>
                successfully saved
              </Typography>
            </Stack>
          ) : (
            <Fade
              in={query === 'progress'}
              style={{
                transitionDelay: query === 'progress' ? '800ms' : '0ms',
              }}
              unmountOnExit
            >
              <CircularProgress size={20}/>
            </Fade>
          )}
        </Stack>

      </Stack>


      {openConfirmDialog && (
        <ConfirmDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={() => {
            handleDelete(openConfirmDialog.id);
          }}
        />
      )}

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            setOpenedSlidingPane({});
            fetchGuides();
            fetchRoomPrices();

            setQuery('progress');
            timerRef.current = setTimeout(() => {
              setQuery('success');
            }, 2000);
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}

      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: {}});
              fetchGuides();
              fetchRoomPrices();
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: {}});
            }}
          />
        </>
      )}
    </>
  );
};

CustomFieldForAccommodationRoom.includes = (query, value) => true;

CustomFieldForAccommodationRoom.comparator = () => 0;

CustomFieldForAccommodationRoom.FilterRenderer = TimeFilter;
